// Program.programType predates a single canonical storage format. Production
// tenants contain display labels ("Behavioral Health"), snake_case values, and
// kebab-case values. Permission checks must treat those representations as the
// same program type or valid users can be incorrectly denied client access.
export const normalizeProgramType = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/&/g, 'and')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

export const matchesProgramType = (value, aliases) => {
  const normalizedValue = normalizeProgramType(value);
  return aliases.some((alias) => normalizeProgramType(alias) === normalizedValue);
};

// Minnesota 144G Residential Services (assisted living / customized living).
// Mirrors isResidentialProgramType in evv-backend/src/utils/programBundleRequirement.js:
// a bare "residential" also names 245D residential support and IRTS, so only
// these phrases count, and any 245D name never does.
// Case Management (targeted case management, bundle 'case-management').
// Mirrors isCaseManagementProgramType in evv-backend/src/utils/programBundleRequirement.js;
// checked before the Behavioral Health keywords because an MH-TCM program is
// often named "Adult Mental Health Targeted Case Management".
export const isCaseManagementProgramName = (value) => {
  const text = String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  return text === 'casemanagement' || text.includes('targetedcasemanagement');
};

export const isResidentialProgramName = (value) => {
  const text = String(value || '').toLowerCase();
  if (text.includes('245d')) return false;
  return /residential[\s_-]*services|assisted[\s_-]*living|customized[\s_-]*living|144g/.test(text);
};

// Minnesota Housing Support (chapter 256I, formerly Group Residential Housing).
// Mirrors isHousingSupportProgramType in
// evv-backend/src/utils/programBundleRequirement.js. "Housing Stabilization"
// (the legacy 'Housing Services' program type, ended 10/31/2025) never counts.
export const isHousingSupportProgramName = (value) => {
  const text = String(value || '').toLowerCase();
  if (text.includes('stabilization')) return false;
  return /housing[\s_-]*support|group[\s_-]*residential[\s_-]*housing|\b256i\b/.test(text);
};
